import { TabLink as NextNavLink } from '@framework/router/Next/Link';
import Button from '@creditflowresearch/uilib/Button';
import useLoginUrl from './useLoginUrl';

import styles from './loginButton.module.scss';

const LoginButton = () => {
  const loginUrl = useLoginUrl();

  return (
    <Button
      as={ NextNavLink }
      to={ loginUrl }
      variant="outline"
      color="primary"
      className={ styles.loginButton }
      dataTest="loginButton"
    >
      Log In
    </Button>
  );
};

export default LoginButton;
